export default __webpack_public_path__ + "static/media/sharjeel.270013d2.jpg";